export const handleOrderTokenError = async (response: Response): Promise<boolean> => {
    if (response.status === 500 || response.status === 404 ) {
        console.warn("Order token is invalid or expired. Clearing and redirecting.");
        localStorage.removeItem("orderToken");
        window.location.href = "/";
        return true;
    }
    return false;
};
